(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function getSectionRootFrom(el) {
    return el.closest('[id^="shopify-section-"]') || document;
  }

  function openDialog(modal) {
    if (typeof modal.showModal === "function") {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute("open", "");
      modal.classList.add("is-open-fallback");
    }
  }

  function closeDialog(modal) {
    if (typeof modal.close === "function") {
      if (modal.open) modal.close();
    } else {
      modal.removeAttribute("open");
      modal.classList.remove("is-open-fallback");
    }
  }

  function readTypeConfig(sectionRoot, sectionId, tipo) {
    const el = sectionRoot.querySelector(`script[data-ms-config="${sectionId}"][data-ms-type="${tipo}"]`);
    if (!el) return null;
    try { return JSON.parse(el.textContent || "{}"); } catch(e){ return null; }
  }

  function buildSelect(selectEl, items, placeholder) {
    if (!selectEl) return;
    selectEl.innerHTML = "";
    const ph = document.createElement("option");
    ph.value = "";
    ph.textContent = placeholder || "Selecciona una opción";
    selectEl.appendChild(ph);

    (items || []).forEach((val) => {
      if (!val || typeof val !== "string") return;
      const v = val.trim();
      if (!v) return;
      const opt = document.createElement("option");
      opt.value = v;
      opt.textContent = v;
      selectEl.appendChild(opt);
    });
  }

  function buildChips(container, items) {
    if (!container) return;
    container.innerHTML = "";
    (items || []).forEach((val) => {
      if (!val || typeof val !== "string") return;
      const v = val.trim();
      if (!v) return;

      const label = document.createElement("label");
      label.className = "ms-chip";
      label.setAttribute("role", "listitem");

      const input = document.createElement("input");
      input.type = "checkbox";
      input.value = v;

      const span = document.createElement("span");
      span.textContent = v;

      label.appendChild(input);
      label.appendChild(span);
      container.appendChild(label);
    });
  }

  function getCheckedToppings(modal) {
    return Array.from(modal.querySelectorAll('[data-ms-field="toppings"] input[type="checkbox"]:checked'));
  }

  function syncChipStates(modal) {
    modal.querySelectorAll(".ms-chip").forEach((chip) => {
      const input = chip.querySelector('input[type="checkbox"]');
      if (!input) return;
      chip.classList.toggle("is-selected", input.checked);
    });
  }

  function enforceToppingsLimit(modal) {
    const form = modal.querySelector(".ms-modal__form");
    const max = Number(form?.getAttribute("data-ms-max-toppings") || 0);

    const checked = getCheckedToppings(modal);
    const count = checked.length;

    const countEl = modal.querySelector("[data-ms-toppings-count]");
    const maxEl = modal.querySelector("[data-ms-toppings-max]");
    if (countEl) countEl.textContent = String(count);

    const allInputs = Array.from(modal.querySelectorAll('[data-ms-field="toppings"] input[type="checkbox"]'));
    const help = modal.querySelector("[data-ms-help]");

    if (max <= 0) {
      if (maxEl) maxEl.textContent = "∞";
      allInputs.forEach((input) => {
        const chip = input.closest(".ms-chip");
        input.disabled = false;
        if (chip) chip.classList.remove("is-disabled");
      });
      if (help) help.innerHTML = "Puedes elegir los toppings que quieras.";
      return;
    }

    if (maxEl) maxEl.textContent = String(max);

    const atLimit = count >= max;

    allInputs.forEach((input) => {
      const chip = input.closest(".ms-chip");
      if (!chip) return;
      const shouldDisable = atLimit && !input.checked;
      input.disabled = shouldDisable;
      chip.classList.toggle("is-disabled", shouldDisable);
    });

    if (help) {
      help.innerHTML = atLimit
        ? `Llegaste al máximo de <b>${max}</b> toppings. Para cambiar, desmarca uno.`
        : `Puedes elegir hasta <b>${max}</b> toppings.`;
    }
  }

  function syncSummary(modal) {
    const propTipo = modal.querySelector('[data-ms-prop="tipo"]');
    const propBase = modal.querySelector('[data-ms-prop="base"]');
    const propPan  = modal.querySelector('[data-ms-prop="pan"]');
    const propProt = modal.querySelector('[data-ms-prop="proteina"]');
    const propAdz  = modal.querySelector('[data-ms-prop="aderezo"]');
    const propTops = modal.querySelector('[data-ms-prop="toppings"]');
    const summaryText = modal.querySelector("[data-ms-summary-text]");

    const tipo = modal.querySelector('[data-ms-field="tipo"]')?.value || "Sopa";
    const primary = modal.querySelector('[data-ms-field="primary"]')?.value || "";
    const prot = modal.querySelector('[data-ms-field="proteina"]')?.value || "";
    const adz = modal.querySelector('[data-ms-field="aderezo"]')?.value || "";
    const tops = getCheckedToppings(modal).map((i) => i.value);

    if (propTipo) propTipo.value = tipo;

    const isPan = (tipo === "Bagel" || tipo === "Sandwich");
    const hasAderezo = (tipo === "Ensalada" || tipo === "Bowl" || tipo === "Bagel" || tipo === "Sandwich");

    if (propBase) propBase.value = isPan ? "" : primary;
    if (propPan)  propPan.value  = isPan ? primary : "";
    if (propProt) propProt.value = prot;
    if (propAdz) propAdz.value = hasAderezo ? adz : "";
    if (propTops) propTops.value = tops.join(", ");

    const parts = [];
    parts.push(`Categoría: ${tipo}`);
    if (primary) parts.push(`${isPan ? "Pan" : "Base"}: ${primary}`);
    if (prot) parts.push(`Proteína: ${prot}`);
    if (hasAderezo && adz) parts.push(`Aderezo: ${adz}`);
    if (tops.length) parts.push(`Toppings: ${tops.join(", ")}`);

    if (summaryText) summaryText.textContent = parts.join(" · ") || "—";
  }

  function resetInputs(modal) {
    const primary = modal.querySelector('[data-ms-field="primary"]');
    const prot = modal.querySelector('[data-ms-field="proteina"]');
    const adz = modal.querySelector('[data-ms-field="aderezo"]');

    if (primary) primary.value = "";
    if (prot) prot.value = "";
    if (adz) adz.value = "";

    modal.querySelectorAll('[data-ms-field="toppings"] input[type="checkbox"]').forEach((c) => {
      c.checked = false;
      c.disabled = false;
    });
    syncChipStates(modal);
  }

  function applyTypeToModal(modal, sectionRoot, sectionId, tipo, keepSelections) {
    const cfg = readTypeConfig(sectionRoot, sectionId, tipo);
    if (!cfg) return;

    const form = modal.querySelector(".ms-modal__form");
    const variantInput = modal.querySelector('.ms-modal__form input[name="id"]');

    const primaryLabel = modal.querySelector("[data-ms-primary-label]");
    const primarySelect = modal.querySelector('[data-ms-field="primary"]');
    const protSelect = modal.querySelector('[data-ms-field="proteina"]');
    const adzWrap = modal.querySelector('[data-ms-wrap="aderezo"]');
    const adzSelect = modal.querySelector('[data-ms-field="aderezo"]');
    const chipsWrap = modal.querySelector('[data-ms-field="toppings"]');

    if (primaryLabel) primaryLabel.textContent = cfg.primary_label || "Base";

    buildSelect(primarySelect, cfg.primary_options || [], cfg.primary_placeholder || "Selecciona una opción");
    buildSelect(protSelect, cfg.proteinas || [], "Selecciona proteína");
    buildChips(chipsWrap, cfg.toppings || []);

    const showAderezo = (tipo === "Ensalada" || tipo === "Bowl" || tipo === "Bagel" || tipo === "Sandwich");
    if (adzWrap) adzWrap.hidden = !showAderezo;

    if (adzSelect) {
      if (showAderezo) {
        buildSelect(adzSelect, cfg.aderezos || [], "Selecciona aderezo");
        adzSelect.required = Array.isArray(cfg.aderezos) && cfg.aderezos.length > 0;
      } else {
        adzSelect.innerHTML = "";
        adzSelect.required = false;
      }
    }

    const rawMax = Number(cfg.max_toppings || 0);
    const max = (rawMax <= 0) ? 0 : rawMax;
    if (form) form.setAttribute("data-ms-max-toppings", String(max));

    const maxEl = modal.querySelector("[data-ms-toppings-max]");
    if (maxEl) maxEl.textContent = (max <= 0) ? "∞" : String(max);

    if (variantInput && cfg.variant_id) variantInput.value = cfg.variant_id;

    if (!keepSelections) resetInputs(modal);

    enforceToppingsLimit(modal);
    syncSummary(modal);
  }

  function openPersonalize(btn) {
    const sectionRoot = getSectionRootFrom(btn);
    const results = sectionRoot.querySelector("results-list");
    const sectionId = results?.getAttribute("section-id") || "";
    const modal = sectionRoot.querySelector(".ms-modal");
    if (!modal) return;

    const form = modal.querySelector(".ms-modal__form");
    if (!form) return;

    const tipoSelect = modal.querySelector('[data-ms-field="tipo"]');
    const tipo = (tipoSelect && tipoSelect.value) ? tipoSelect.value : "Sopa";
    applyTypeToModal(modal, sectionRoot, sectionId, tipo, false);

    openDialog(modal);
  }

  function autoOpenIfHashMatches() {
    if (window.location.hash !== "#msPersonalizar") return;
    const btn = document.querySelector('[data-ms-open]');
    if (btn) openPersonalize(btn);
  }

  function fixCategoryHashScroll() {
    const hash = window.location.hash || "";
    if (!hash) return;
    if (!hash.startsWith("#msCat")) return;

    const el = document.querySelector(hash);
    if (!el) return;

    setTimeout(() => { try { el.scrollIntoView({ block: "start", inline: "nearest" }); } catch(e){} }, 0);
    setTimeout(() => { try { el.scrollIntoView({ block: "start", inline: "nearest" }); } catch(e){} }, 250);
  }

  window.addEventListener("load", () => {
    setTimeout(autoOpenIfHashMatches, 0);
    setTimeout(fixCategoryHashScroll, 0);
  });

  window.addEventListener("hashchange", () => {
    setTimeout(autoOpenIfHashMatches, 0);
    setTimeout(fixCategoryHashScroll, 0);
  });

  document.addEventListener("click", (ev) => {
    const openBtn = ev.target.closest("[data-ms-open]");
    if (openBtn) {
      ev.preventDefault();
      openPersonalize(openBtn);
      return;
    }

    const closeBtn = ev.target.closest("[data-ms-close]");
    if (closeBtn) {
      const sectionRoot = getSectionRootFrom(closeBtn);
      const modal = sectionRoot.querySelector(".ms-modal");
      if (modal) closeDialog(modal);
      return;
    }

    const dialog = ev.target;
    if (dialog && dialog.tagName === "DIALOG") {
      closeDialog(dialog);
    }
  });

  document.addEventListener("change", (ev) => {
    const modal = ev.target.closest(".ms-modal");
    if (!modal) return;

    const sectionRoot = getSectionRootFrom(modal);
    const results = sectionRoot.querySelector("results-list");
    const sectionId = results?.getAttribute("section-id") || "";

    if (ev.target.matches('[data-ms-field="tipo"]')) {
      const tipo = ev.target.value || "Sopa";
      applyTypeToModal(modal, sectionRoot, sectionId, tipo, false);
      return;
    }

    if (
      ev.target.closest('[data-ms-field="primary"]') ||
      ev.target.closest('[data-ms-field="proteina"]') ||
      ev.target.closest('[data-ms-field="aderezo"]') ||
      ev.target.closest('[data-ms-field="toppings"]')
    ) {
      syncChipStates(modal);
      enforceToppingsLimit(modal);
      syncSummary(modal);
    }
  });

  document.addEventListener("click", (ev) => {
    const input = ev.target.closest('[data-ms-field="toppings"] input[type="checkbox"]');
    if (!input) return;

    const modal = input.closest(".ms-modal");
    if (!modal) return;

    const form = modal.querySelector(".ms-modal__form");
    const max = Number(form?.getAttribute("data-ms-max-toppings") || 0);

    if (input.disabled) return;

    setTimeout(() => {
      if (max > 0) {
        const checked = getCheckedToppings(modal);
        if (checked.length > max) input.checked = false;
      }
      syncChipStates(modal);
      enforceToppingsLimit(modal);
      syncSummary(modal);
    }, 0);
  });

  document.addEventListener("submit", (ev) => {
    const form = ev.target.closest(".ms-modal__form");
    if (!form) return;

    const modal = form.closest(".ms-modal");
    if (!modal) return;

    enforceToppingsLimit(modal);
    syncChipStates(modal);
    syncSummary(modal);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  function getSectionRootFrom(el) {
    return el.closest('[id^="shopify-section-"]') || document;
  }

  function openDialog(modal) {
    if (typeof modal.showModal === "function") {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute("open", "");
      modal.classList.add("is-open-fallback");
    }
  }

  function closeDialog(modal) {
    if (typeof modal.close === "function") {
      if (modal.open) modal.close();
    } else {
      modal.removeAttribute("open");
      modal.classList.remove("is-open-fallback");
    }
  }

  function readTypeConfig(sectionRoot, sectionId, tipo) {
    let el = null;
    if (sectionId) {
      el = sectionRoot.querySelector(`script[data-ms-config="${sectionId}"][data-ms-type="${tipo}"]`);
    }
    if (!el) {
      el = sectionRoot.querySelector(`script[data-ms-type="${tipo}"]`);
    }
    if (!el) return null;
    try { return JSON.parse(el.textContent || "{}"); } catch(e){ return null; }
  }

  function buildSelect(selectEl, items, placeholder) {
    if (!selectEl) return;
    selectEl.innerHTML = "";
    const ph = document.createElement("option");
    ph.value = "";
    ph.textContent = placeholder || "Selecciona una opción";
    selectEl.appendChild(ph);

    (items || []).forEach((val) => {
      if (!val || typeof val !== "string") return;
      const v = val.trim();
      if (!v) return;
      const opt = document.createElement("option");
      opt.value = v;
      opt.textContent = v;
      selectEl.appendChild(opt);
    });
  }

  function buildChips(container, items) {
    if (!container) return;
    container.innerHTML = "";
    (items || []).forEach((val) => {
      if (!val || typeof val !== "string") return;
      const v = val.trim();
      if (!v) return;

      const label = document.createElement("label");
      label.className = "ms-chip";
      label.setAttribute("role", "listitem");

      const input = document.createElement("input");
      input.type = "checkbox";
      input.value = v;

      const span = document.createElement("span");
      span.textContent = v;

      label.appendChild(input);
      label.appendChild(span);
      container.appendChild(label);
    });
  }

  function getCheckedToppings(modal) {
    return Array.from(modal.querySelectorAll('[data-ms-field="toppings"] input[type="checkbox"]:checked'));
  }

  function syncChipStates(modal) {
    modal.querySelectorAll(".ms-chip").forEach((chip) => {
      const input = chip.querySelector('input[type="checkbox"]');
      if (!input) return;
      chip.classList.toggle("is-selected", input.checked);
    });
  }

  function enforceToppingsLimit(modal) {
    const form = modal.querySelector(".ms-modal__form");
    const max = Number(form?.getAttribute("data-ms-max-toppings") || 0);

    const checked = getCheckedToppings(modal);
    const count = checked.length;

    const countEl = modal.querySelector("[data-ms-toppings-count]");
    const maxEl = modal.querySelector("[data-ms-toppings-max]");
    if (countEl) countEl.textContent = String(count);

    const allInputs = Array.from(modal.querySelectorAll('[data-ms-field="toppings"] input[type="checkbox"]'));
    const help = modal.querySelector("[data-ms-help]");

    if (max <= 0) {
      if (maxEl) maxEl.textContent = "∞";
      allInputs.forEach((input) => {
        const chip = input.closest(".ms-chip");
        input.disabled = false;
        if (chip) chip.classList.remove("is-disabled");
      });
      if (help) help.innerHTML = "Puedes elegir los toppings que quieras.";
      return;
    }

    if (maxEl) maxEl.textContent = String(max);

    const atLimit = count >= max;

    allInputs.forEach((input) => {
      const chip = input.closest(".ms-chip");
      if (!chip) return;
      const shouldDisable = atLimit && !input.checked;
      input.disabled = shouldDisable;
      chip.classList.toggle("is-disabled", shouldDisable);
    });

    if (help) {
      help.innerHTML = atLimit
        ? `Llegaste al máximo de <b>${max}</b> toppings. Para cambiar, desmarca uno.`
        : `Puedes elegir hasta <b>${max}</b> toppings.`;
    }
  }

  function syncSummary(modal) {
    const propTipo = modal.querySelector('[data-ms-prop="tipo"]');
    const propBase = modal.querySelector('[data-ms-prop="base"]');
    const propPan  = modal.querySelector('[data-ms-prop="pan"]');
    const propProt = modal.querySelector('[data-ms-prop="proteina"]');
    const propAdz  = modal.querySelector('[data-ms-prop="aderezo"]');
    const propTops = modal.querySelector('[data-ms-prop="toppings"]');
    const summaryText = modal.querySelector("[data-ms-summary-text]");

    const tipoEl = modal.querySelector('[data-ms-field="tipo"]');
    const tipo = (tipoEl && tipoEl.value) ? tipoEl.value : "Sopa";

    const primary = modal.querySelector('[data-ms-field="primary"]')?.value || "";
    const prot = modal.querySelector('[data-ms-field="proteina"]')?.value || "";
    const adz = modal.querySelector('[data-ms-field="aderezo"]')?.value || "";
    const tops = getCheckedToppings(modal).map((i) => i.value);

    if (propTipo) propTipo.value = tipo;

    const isPan = (tipo === "Bagel" || tipo === "Sandwich");
    const hasAderezo = (tipo === "Ensalada" || tipo === "Bowl" || tipo === "Bagel" || tipo === "Sandwich");

    if (propBase) propBase.value = isPan ? "" : primary;
    if (propPan)  propPan.value  = isPan ? primary : "";
    if (propProt) propProt.value = prot;
    if (propAdz) propAdz.value = hasAderezo ? adz : "";
    if (propTops) propTops.value = tops.join(", ");

    const parts = [];
    parts.push(`Categoría: ${tipo}`);
    if (primary) parts.push(`${isPan ? "Pan" : "Base"}: ${primary}`);
    if (prot) parts.push(`Proteína: ${prot}`);
    if (hasAderezo && adz) parts.push(`Aderezo: ${adz}`);
    if (tops.length) parts.push(`Toppings: ${tops.join(", ")}`);

    if (summaryText) summaryText.textContent = parts.join(" · ") || "—";
  }

  function resetInputs(modal) {
    const primary = modal.querySelector('[data-ms-field="primary"]');
    const prot = modal.querySelector('[data-ms-field="proteina"]');
    const adz = modal.querySelector('[data-ms-field="aderezo"]');

    if (primary) primary.value = "";
    if (prot) prot.value = "";
    if (adz) adz.value = "";

    modal.querySelectorAll('[data-ms-field="toppings"] input[type="checkbox"]').forEach((c) => {
      c.checked = false;
      c.disabled = false;
    });
    syncChipStates(modal);
  }

  function applyTypeToModal(modal, sectionRoot, sectionId, tipo, keepSelections) {
    const cfg = readTypeConfig(sectionRoot, sectionId, tipo);
    if (!cfg) return;

    const form = modal.querySelector(".ms-modal__form");
    const variantInput = modal.querySelector('.ms-modal__form input[name="id"]');

    const primaryLabel = modal.querySelector("[data-ms-primary-label]");
    const primarySelect = modal.querySelector('[data-ms-field="primary"]');
    const protSelect = modal.querySelector('[data-ms-field="proteina"]');
    const adzWrap = modal.querySelector('[data-ms-wrap="aderezo"]');
    const adzSelect = modal.querySelector('[data-ms-field="aderezo"]');
    const chipsWrap = modal.querySelector('[data-ms-field="toppings"]');

    if (primaryLabel) primaryLabel.textContent = cfg.primary_label || "Base";

    buildSelect(primarySelect, cfg.primary_options || [], cfg.primary_placeholder || "Selecciona una opción");
    buildSelect(protSelect, cfg.proteinas || [], "Selecciona proteína");
    buildChips(chipsWrap, cfg.toppings || []);

    const showAderezo = (tipo === "Ensalada" || tipo === "Bowl" || tipo === "Bagel" || tipo === "Sandwich");
    if (adzWrap) adzWrap.hidden = !showAderezo;

    if (adzSelect) {
      if (showAderezo) {
        buildSelect(adzSelect, cfg.aderezos || [], "Selecciona aderezo");
        adzSelect.required = Array.isArray(cfg.aderezos) && cfg.aderezos.length > 0;
      } else {
        adzSelect.innerHTML = "";
        adzSelect.required = false;
      }
    }

    const rawMax = Number(cfg.max_toppings || 0);
    const max = (rawMax <= 0) ? 0 : rawMax;
    if (form) form.setAttribute("data-ms-max-toppings", String(max));

    const maxEl = modal.querySelector("[data-ms-toppings-max]");
    if (maxEl) maxEl.textContent = (max <= 0) ? "∞" : String(max);

    if (variantInput && cfg.variant_id) variantInput.value = cfg.variant_id;

    if (!keepSelections) resetInputs(modal);

    enforceToppingsLimit(modal);
    syncSummary(modal);
  }

  function openPersonalize(btn) {
    const sectionRoot = getSectionRootFrom(btn);
    const modal = sectionRoot.querySelector(".ms-modal");
    if (!modal) return;

    const sectionId =
      sectionRoot.querySelector("results-list")?.getAttribute("section-id")
      || sectionRoot.querySelector("[data-ms-section]")?.getAttribute("data-ms-section")
      || "";

    const tipoSelect = modal.querySelector('[data-ms-field="tipo"]');
    const tipo = (tipoSelect && tipoSelect.value) ? tipoSelect.value : "Sopa";
    applyTypeToModal(modal, sectionRoot, sectionId, tipo, false);

    openDialog(modal);
  }

  function autoOpenIfHashMatches() {
    if (window.location.hash !== "#msPersonalizar") return;
    const btn = document.querySelector('[data-ms-open]');
    if (btn) openPersonalize(btn);
  }

  function fixCategoryHashScroll() {
    const hash = window.location.hash || "";
    if (!hash) return;
    if (!hash.startsWith("#msCat")) return;

    const el = document.querySelector(hash);
    if (!el) return;

    setTimeout(() => { try { el.scrollIntoView({ block: "start", inline: "nearest" }); } catch(e){} }, 0);
    setTimeout(() => { try { el.scrollIntoView({ block: "start", inline: "nearest" }); } catch(e){} }, 250);
  }

  window.addEventListener("load", () => {
    setTimeout(autoOpenIfHashMatches, 0);
    setTimeout(fixCategoryHashScroll, 0);
  });

  window.addEventListener("hashchange", () => {
    setTimeout(autoOpenIfHashMatches, 0);
    setTimeout(fixCategoryHashScroll, 0);
  });

  document.addEventListener("click", (ev) => {
    const openBtn = ev.target.closest("[data-ms-open]");
    if (openBtn) {
      ev.preventDefault();
      openPersonalize(openBtn);
      return;
    }

    const closeBtn = ev.target.closest("[data-ms-close]");
    if (closeBtn) {
      const sectionRoot = getSectionRootFrom(closeBtn);
      const modal = sectionRoot.querySelector(".ms-modal");
      if (modal) closeDialog(modal);
      return;
    }

    const dialog = ev.target;
    if (dialog && dialog.tagName === "DIALOG") {
      closeDialog(dialog);
    }
  });

  document.addEventListener("change", (ev) => {
    const modal = ev.target.closest(".ms-modal");
    if (!modal) return;

    const sectionRoot = getSectionRootFrom(modal);
    const sectionId =
      sectionRoot.querySelector("results-list")?.getAttribute("section-id")
      || sectionRoot.querySelector("[data-ms-section]")?.getAttribute("data-ms-section")
      || "";

    if (ev.target.matches('[data-ms-field="tipo"]')) {
      const tipo = ev.target.value || "Sopa";
      applyTypeToModal(modal, sectionRoot, sectionId, tipo, false);
      return;
    }

    if (
      ev.target.closest('[data-ms-field="primary"]') ||
      ev.target.closest('[data-ms-field="proteina"]') ||
      ev.target.closest('[data-ms-field="aderezo"]') ||
      ev.target.closest('[data-ms-field="toppings"]')
    ) {
      syncChipStates(modal);
      enforceToppingsLimit(modal);
      syncSummary(modal);
    }
  });

  document.addEventListener("click", (ev) => {
    const input = ev.target.closest('[data-ms-field="toppings"] input[type="checkbox"]');
    if (!input) return;

    const modal = input.closest(".ms-modal");
    if (!modal) return;

    const form = modal.querySelector(".ms-modal__form");
    const max = Number(form?.getAttribute("data-ms-max-toppings") || 0);

    if (input.disabled) return;

    setTimeout(() => {
      if (max > 0) {
        const checked = getCheckedToppings(modal);
        if (checked.length > max) input.checked = false;
      }
      syncChipStates(modal);
      enforceToppingsLimit(modal);
      syncSummary(modal);
    }, 0);
  });

  document.addEventListener("submit", (ev) => {
    const form = ev.target.closest(".ms-modal__form");
    if (!form) return;

    const modal = form.closest(".ms-modal");
    if (!modal) return;

    enforceToppingsLimit(modal);
    syncChipStates(modal);
    syncSummary(modal);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
